
import { send, on } from "@rlx/feim";
import PointerEvents from '../../../core/src/const/PointerEvents';
import ErrorModel from '../../../core/src/model/ErrorModel';
import GameModel from '../../../core/src/model/GameModel';
import ErrorPopup from '../../../core/src/ui/popups/ErrorPopup';
import { DefaultLayers } from '../../../core/src/utils/Layers';
import Locale, { LocaleId } from '../../../core/src/utils/Locale';
import ViewManager from '../../../core/src/utils/ViewManager';
import Button from '../../../core/src/views/components/Button';
import TextField from '../../../core/src/views/components/TextField';
import Utils from '../../../core/src/utils/Utils';

export default class VendorErrorPopup extends ErrorPopup {
    public tempText?: TextField;
    private timer: NodeJS.Timeout;

    public async show(callback?: Function,forcedText?:string) {
        const errorCode = ErrorModel.errorCode;
        on.errorMessageDismissed( () => this.finish(callback) );
        const erorrHandledByOperator = send.errorMessage(ErrorModel.rawError);

        if (erorrHandledByOperator) {
            this.hide();
        } else {
            super.show();
        ViewManager.getLayer(DefaultLayers.SplashOverlay).setScene("open");
        const errorTranslationKey = 'error.' + ErrorModel.errorCode;
        const is559 = ErrorModel.errorCode === 559;
        let text = forcedText || Locale.getString(errorTranslationKey);
        // if (!App.assets.loaded) {
        //     this.hide();
        //     alert("Error: " + (forcedText || Locale.getString(errorModel.errorMessage + "\nErrorCode: " + errorModel.errorCode)));
        //     return;
        // }

        if (!Locale.isTranslated(text, errorTranslationKey)) {
            // No translation for this error
            text = !Utils.isNullOrWhiteSpace(ErrorModel.errorMessage) ? ErrorModel.errorMessage : text;
        }

        this.scene = this.layer.setScene("error");
        this.scene.interactive = true;
        this.tempText = this.scene.sceneTextFields.get("tempText") as TextField;

        const closeBtn = this.scene.buttons.get("close");
        const okBtn = this.scene.buttons.get("monetary_ok");

        closeBtn ? closeBtn.renderable = false : null;

        if(okBtn){
            okBtn.renderable = false;
        }
        if(closeBtn){
            this.closeBtn = closeBtn;
        }

        if(this.tempText) {
            this.tempText.renderable = false;
        }
        this.text = this.scene.sceneTextFields.get("text") as TextField;
        this.text.text = text;
        this.title = this.scene.sceneTextFields.get("title") as TextField;
        this.title.text = Locale.getString(LocaleId.gui_lbl_error);
        if(Locale.getString(LocaleId.gui_lbl_error)==="|gui_lbl_error|")
        {
            this.title.text="Error";
        }

        if(is559) {
            okBtn ? this.closeBtn = okBtn : null;
            this.title.text = ErrorModel.displayMessage
            this.tempText.text = text;
            this.tempText.renderable = true;
            this.text.text = ErrorModel.errorMessage;
            await this.startTimer();
            this.tempText.renderable = false;
        } else {
            okBtn?.destroy();
        }

        this.closeBtn ? this.closeBtn.renderable = true : null;

        this.closeBtn?.once(PointerEvents.DOWN, (e) => {
            e.stopPropagation();
            this.finish(callback, errorCode)
        });
        }
    }

    public setText(value: string) {
        this.text.text = value;
    }

    public setTitle(value: string) {
        this.title.text = value;
    }

    public hide(): void {
        super.hide();
        ErrorModel.errorCode = -1;
    }

    protected hideFromKeyboard() {}

    private finish(callback, errorCode?: number) {

        if (callback) {
            callback();
        }
        // If error is "not enough money" try to open quic deposit popup if operator is support it
        if (errorCode && errorCode == 506) {
            send.openQuickDeposit();
        }

        ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
        this.hide();
    }
    private async startTimer() {

        const timer = new Promise(resolve => {

            let time = GameModel.jurisdiction === 'GR' ? 15 : 0;

            if(time === 0) {
                resolve();
            }

            if (this.tempText?.text) {
                this.tempText.renderable = true;
                this.tempText.text = this.tempText.text.replace((/\{\{([^}]+)\}\}/g), `${time}`);

            }
            this.timer = setInterval(() => {

                time--;

                if(time === 0){
                    clearInterval(this.timer);
                    resolve();
                } else {
                    if (this.tempText?.text) {
                        const match = this.tempText.text.match(/(\d+)/);
                        if (match) {
                            this.tempText.text = this.tempText.text.replace(match[1], `${time}`);
                        }
                    }
                }

            }, 1000);

        });


        await timer;
    }
}
